<template>
  <div class="orders-list-table">
    <el-table :data="dataList" ref="multipleTable" @selection-change="onSelectionChange">
      <template v-for="{ type, prop, label, width, slot, align, fixed } in config">
        <el-table-column :key="prop" :label="label" :type="type" :min-width="width" :align="align"
          v-if="type"></el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :fixed="fixed" :align="align"
          v-else-if="slot">
          <template slot-scope="scope">
            <template v-if="slot === 'no'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="itemN" :style="{ zIndex: 100 - scope.$index }">
                <div style="display: flex">
                  <div style="margin-left: 40px; cursor: pointer" @click="copyInfo(scope.row.orderNo)">
                    订单编号：{{ scope.row.orderNo }}
                  </div>
                  <div class="hint_pr">
                    下单时间：{{ scope.row.orderTime }}
                  </div>
                  <div class="hint_pr">
                    提交时间：{{ scope.row.createdTime }}
                  </div>
                  <div class="hint_pr">
                    审核时间：{{ scope.row.approveTime || '-' }}
                  </div>
                </div>
                <div class="hint_pr-operation" style="margin-right: 50px">
                  <template>
                    <!-- <label style="color: #2d46ee" @click="
                      toOtherPages('inflowAfterOrderDetail', scope.row, 'Details')
                      ">查看</label>
                    <label v-if="scope.row.status == 1" style="color: #2d46ee; margin-left: 10px"
                      @click="apply(scope.row)">审核</label> -->
                    <el-dropdown placement="bottom" @command="handleCommand($event, scope.row)">
                      <span class="el-dropdown-link" style="color: #4168e7;cursor:pointer">
                        更多<i class="el-icon-arrow-down el-icon--right" style="color: #4168e7"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">查看</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="scope.row.status == 1">审核</el-dropdown-item>
                        <el-dropdown-item command="3" v-if="scope.row.status == 5">换货寄出</el-dropdown-item>
                        <el-dropdown-item command="4" v-if="scope.row.status == 6">修改换货单号</el-dropdown-item>
                        <el-dropdown-item command="5" v-if="scope.row.status == 3">退货单号</el-dropdown-item>
                        <el-dropdown-item command="6" v-if="scope.row.status == 4">修改退货单号</el-dropdown-item>
                        <el-dropdown-item command="7" v-if="scope.row.status == 4">查看退货物流</el-dropdown-item>
                        <el-dropdown-item command="8" v-if="scope.row.status == 6">查看换货物流</el-dropdown-item>
                        <el-dropdown-item command="9" v-if="scope.row.status == 6">确认收货</el-dropdown-item>
                        <el-dropdown-item command="10" v-if="scope.row.status == 4">确认收货</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </div>
              </div>
              <div>{{ scope.row.afterNo }}</div>
            </template>
            <template v-if="slot === 'info'">
              <div v-if="scope.row.orderAfterDetailList">
                <div class="mesSty" v-for="(item, index) in scope.row.orderAfterDetailList" :key="index">
                  <!-- <img class="imgSty" src="https://dummyimage.com/72x54/FF6600" alt="">-->
                  <el-image :src="item.goodsImg" fit="cover"></el-image>
                  <div class="mesFont">
                    <div style="
                        width: 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-left: 8px;
                      ">
                      {{ item.goodsName }}
                    </div>
                    <div style="
                        width: 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-left: 8px;
                        font-size: 13px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 17px;
                        color: #606066;
                      ">
                      规格：{{ item.goodsSkuName }} * {{ item.afterQuantity }}
                    </div>

                    <!-- <p :title="item.goodsName + '*' + item.afterQuantity">
                      <span>{{ item.goodsName }}</span>
                    </p>
                    <p>{{ item.goodsSkuName }} * {{ item.afterQuantity }}</p> -->
                  </div>
                </div>
              </div>
            </template>
            <template v-if="slot === 'user'">
              <p>{{ scope.row.userName }}</p>
              <p>ID:{{ scope.row.userId }}</p>
              <p>{{ scope.row.userPhone }}</p>
            </template>
            <template v-if="slot === 'post'">
              <p>{{ scope.row.postName }}</p>
              <p>{{ scope.row.postPhone }}</p>
            </template>
            <template v-if="slot === 'postAddress'">
              <p>{{ scope.row.postDistrictAddress }}{{ scope.row.postAddress }}</p>
            </template>
            <template v-if="slot === 'afterMoney'">
              <p>{{ Number(scope.row.afterMoney).toFixed(2) }}</p>
            </template>
            <template v-if="slot === 'afterReason'">
              <p>{{ scope.row.afterReason || "--" }}</p>
            </template>
            <template v-if="slot === 'status'">
              <p :title="scope.row.statusLabel">
                <i v-bind:class="[
                  { 'danger-bg': scope.row.status == 2 },
                  { 'info-bg': scope.row.status == 7 },
                  {
                    'warning-bg':
                      scope.row.status == 1 ||
                      scope.row.status == 3 ||
                      scope.row.status == 4 ||
                      scope.row.status == 5 ||
                      scope.row.status == 6,
                  },
                  'round',
                  { 'success-bg': scope.row.status === 8 },
                ]"></i>
                {{ scope.row.statusLabel }}
              </p>
            </template>
            <template v-if="slot === 'afterRemark'">
              <p>{{ scope.row.approveRemark || "--" }}</p>
            </template>
          </template>
        </el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :align="align"
          v-else></el-table-column>
      </template>
    </el-table>
    <el-dialog title="售后申请" :visible.sync="isApply" width="40%" :append-to-body="true">
      <template>
        <div class="info">是否审核通过？</div>
        <div style="margin-top: 18px">
          <el-radio-group v-model="status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </div>
        <div v-if="status == 1 && afterType == 0" class="pass">
          确认后，金额<span class="price">￥{{ refundMoney }}</span>将退回买家账户
        </div>
        <div v-if="status == 1 && afterType != 0" style="margin-top:10px" class="sTable">
          <el-table :data="gridData" border @row-click="rowClick" v-if="status == 1">
            <el-table-column prop="select" width="50">
              <template slot-scope="scope">
                <el-radio v-model="radioIdSelect" :label="scope.row.id">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="收货人姓名" width="200">
            </el-table-column>
            <el-table-column prop="phone" label="收货人电话" width="200">
            </el-table-column>
            <el-table-column prop="address" label="收货地址"> </el-table-column>
          </el-table>
        </div>
        <div v-if="status == 2" style="margin-top: 24px; width: 100%; margin-bottom: 24px">
          <div style="display: flex">
            <div style="margin-right: 8px; width: 10%">备注</div>
            <div style="width: 100%">
              <el-input v-model="remark" type="textarea" style="width: 100%" placeholder="请输入备注" maxlength="200"
                show-word-limit rows="5">
              </el-input>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isApply = false">取消</div>
          <div class="info-s" @click="submitApply()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isInfo" width="518px" :append-to-body="true">
      <template>
        <div style="font-size: 20px">是否确认收货?</div>
        <div v-if="this.oStatus == '6'">
          请确认用户是否收货，该操作不可修改！
        </div>
        <div v-else>请确认仓库收货，该操作不可修改！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isInfo = false">取消</div>
          <div class="info-s" @click="submitInfo">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrdersListTable',
  props: {
    afterSale: {
      type: String,
      default: () => ''
    },
    typeStr: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ' '
    },
    heightStr: {
      type: String,
      default: () => '500px'
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    parArrayArr: { // 按钮权限
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      afterType: '0',
      radioIdSelect: '',
      isInfo: false,
      status: 1,
      remark: '',
      refundMoney: null,
      radio: 3,
      isApply: false,
      userInfo: {},
      operationActiveIndex: '1',
      popSty: false,
      isShowCom: {}, // 操作 按钮 组件显示 默认 全为 false
      isShowTime: {
        closedTime: false, // 关闭时间
        createdTime: false, // 下单时间
        finishedTime: false, // 审核时间
        submitDate: false // 提交审核时间
      },
      routeObj: {},
      typeI: '',
      orderId: '',
      gridData: [],
      addressInfo: {
        name: '',
        phone: '',
        address: ''
      },
      oStatus:''
    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        console.log(newVal)
      },
      deep: true
    },
    dataList: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        setTimeout(_ => {
          // this.resetStyle() // 样式调整
        }, 100)
      },
      deep: true
    },
    typeStr(value) {
      // console.log(value)
      this.showCom() // 操作 按钮 组件显示
    },
    // afterSale: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal)
    //   }
    // },
    $route() {
      // this.testFun();
    }
  },
  mounted() {
    // console.log(this.dictionaries.after_sale_reason)
    this.$nextTick(_ => {
      // this.resetDate()
      console.log('afterSale==', this.afterSale)
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.onShowTime()
    })
  },
  created() {
    this.routeObj = this.$route
    this.getList()
  },
  methods: {
    rowClick(row) {
      this.radioIdSelect = row.id
      this.addressInfo.name = row.name
      this.addressInfo.phone = row.phone
      this.addressInfo.address = row.address
    },
    getList() {
      this.axios.get('/orders/after/addressList')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.gridData = res.data
          }
        })
    },
    handleCommand(e, item) {
      console.log(e, item)
      if (e == 1) {
        this.toOtherPages('inflowAfterOrderDetail', item, 'Details')
      } else if (e == 2) {
        this.radioIdSelect = ''
        this.afterType = item.afterType
        this.status = 1
        this.remark = ''
        this.getList()
        this.apply(item)
      } else if (e == 3) {
        this.outGoods(item, 'delivery')
      } else if (e == 4) {
        this.outGoods(item, 'hedit')
      } else if (e == 5) {
        this.outGoods(item, 'fedit')
      } else if (e == 6) {
        this.outGoods(item, 'tedit')
      } else if (e == 7) {
        this.lookInfo(item, 1)
      } else if (e == 8) {
        this.lookInfo(item, 2)
      } else if (e == 9) {
        this.stock(item, 'user')
      } else if (e == 10) {
        this.stock(item, 'five')
      }
    },
    lookInfo(row, type) {
      let data = {
        val: row,
        type: type
      }
      this.$emit('lookDialog', data)
    },
    outGoods(row, type) {
      let data = {
        val: row,
        type: type
      }
      this.$emit('optionDialog', data)
    },
    stock(row, type) {
      this.isInfo = true
      this.typeI = type
      this.oStatus=row.status
      this.orderId = row.id
    },
    submitInfo() {
      if (this.oStatus == 6) {
        let data = {
          orderAfterId: this.orderId
        }
        this.axios.post('/orders/after/logistics/userConfirm', data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '收货成功'
            })
            this.isInfo = false
            this.$parent.fetchData()
          }
        })
      } else {
        let data = {
          orderAfterId: this.orderId
        }
        this.axios.post('/orders/after/logistics/confirm', data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '收货成功'
            })
            this.isInfo = false
            this.$parent.fetchData()
          }
        })
      }
    },
    copyInfo(val) {
      const that = this

      that.$copyText(val).then(
        function (e) {
          that.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          that.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    submitApply() {
      if (this.radioIdSelect == '' && this.afterType != 0 && this.status!=2) {
        this.$message.warning('请选择地址')
        return
      }
      let data = {
        orderAfterId: this.id,
        status: this.status,
        remark: this.remark,
        name: this.addressInfo.name,
        phone: this.addressInfo.phone,
        address: this.addressInfo.address
      }
      this.axios.post('/orders/after/audit', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isApply = false
          this.$parent.fetchData()
        }
      })
    },
    apply(val) {
      this.isApply = true
      this.id = val.id
      this.refundMoney = val.afterMoney
    },
    onShowTime() {
      const routeName = this.$route.name
      switch (routeName) {
        case 'ordersList': // 客服订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'examinationOrderList': // 审核订单
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleOrdeList': // 售后订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleRecordList': // 售后记录
          break
        default:
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.finishedTime = true // 审核时间
        // console.log('%c默认值！👀', 'color:#fff;font-size:1.2rem;padding:0.8rem 1.6rem;border-radius: 5px;background-color: #3eaf7c;font-family: "Microsoft YaHei",Arial,sans-serif;')
      }
      console.log(routeName, this.isShowTime)
    },
    // resetStyle () {
    //   this.$nextTick(_ => {
    //     // 获取 所有行
    //     const elTableRowFirst = document.getElementsByClassName('el-table__row')
    //     elTableRowFirst.forEach((item, index) => {
    //       if (index === 0) {
    //         // 获取  第一行的第二个
    //         // return console.log(item)
    //         const elTableCell = item.getElementsByClassName('el-table__cell')[1]
    //         const elTableCell5 = item.getElementsByClassName('el-table__cell')[5]
    //         const elTableCelldivCell = elTableCell5.getElementsByClassName('cell')[0]

    //         const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
    //         if (!relationOrder) {
    //           elTableCell.style.paddingTop = '45px'
    //           elTableCelldivCell.setAttribute('style', '')
    //           // console.log('没找到关联订单调整 ppadding-top')
    //         } else {
    //           elTableCell.setAttribute('style', '')
    //           elTableCelldivCell.style.marginTop = '30px'
    //         }
    //       } else {
    //         // 获取  其它行的第二个
    //         // return console.log(item)
    //         const elTableCell = item.getElementsByClassName('el-table__cell')[1]
    //         const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
    //         const mesSty = elTableCell.getElementsByClassName('mesSty')[0]
    //         if (relationOrder) {

    //         } else {
    //           mesSty.setAttribute('style', '')
    //         }
    //       }
    //     })
    //   })
    // },
    // 页面跳转
    toOtherPages(name, parameter, type) {
      // console.log(name, parameter, type)
      // console.log(parameter)
      // return
      let query = {}
      query = { orderNo: parameter.orderNo, orderId: parameter.id, id: parameter.id, type: parameter.afterType }
      this.$router.push({ name, query })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },


    onSelectionChange(val) { // 多选
      // this.multipleSelection = val;
      // console.log(val)
      this.$emit('tableSelectionChange', val)
    }
  }
}
</script>
<!--<style scoped>-->
<style lang="scss" scoped>
::v-deep .sTable .el-table .el-table__body .el-table__row td:first-child .cell {
  position: relative;
  top: 30% !important;
  left: 0;
  z-index: 10000;
}

.pass {
  width: 98%;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 2px;
  line-height: 36px;
  padding-left: 12px;
  margin-top: 24px;
  margin-bottom: 100px;

  .price {
    color: #f63c56;
  }
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.tooltip {
  position: relative;
  /*margin: 50px auto;*/
  /*border: 1px solid;*/
  cursor: pointer;
}

.tooltip[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  bottom: -38px;
  left: 30%;
  /*border: 1px solid;*/
  width: 80px;
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  color: #ffffff;
  font-size: 12px !important;
  background-color: rgba(0, 0, 0, 0.5);
}

.mesSty:after {
  clear: both;
  display: table;
  content: "";
}

/*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #0b7df3;
  display: inline-block;
}

.primary-bg {
  background-color: #409eff !important;
}

.success-bg {
  background-color: #12ab62 !important;
}

.warning-bg {
  background-color: #e6a23c !important;
}

.danger-bg {
  background-color: #f56c6c !important;
}

.info-bg {
  background-color: #909399 !important;
}

.el-table {
  overflow: unset;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 14px;
}

/deep/ .el-table tr {
  position: relative;
  width: 100%;
}

/deep/ .el-table .el-table__body-wrapper {
  /*padding-top: 40px;*/
  overflow: unset;
}

::v-deep.el-table .el-table__body .el-table__row {
  position: relative !important;
}

::v-deep.el-table .el-table__body .el-table__row:first-child {
  /*background-color: #2D7EDF;*/
}

::v-deep .el-table .el-table__body .el-table__row td:first-child .cell {
  position: absolute;
  top: 8px;
  left: 0;
  z-index: 10000;
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:first-child .cell {
  top: 8px;
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
  position: static !important;
  /*padding: 5px 0;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(1) {
  /*position:relative!important;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell {
  // background-color: #0b7df3;
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row:first-child .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
  /*background-color: #0b7df3;*/
  padding-top: 60px;
  /*padding-bottom: 15px;*/
}

::v-deep.orders-list-table .el-table .el-table__row:first-child .el-table__cell:nth-child(2) .item {
  /*background-color: #0b7df3;*/
  margin-top: 0;
}

::v-deep.orders-list-table .el-table .el-table__cell:nth-child(2) .item {
  /*background-color: #0b7df3;*/
  margin-top: -44px;
}

.item {
  width: 100%;
  height: 40px;
  background-color: #ebeef5;
  padding: 7px 0 7px 50px;
  position: absolute;
  /*top: 0;*/
  left: 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.itemN {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  background-color: #ebeef5;
  // padding: 7px 0 7px 50px;
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: 20px;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

::v-deep.el-table .el-table__body .el-table__row:first-child td:nth-child(2) .item {
  top: 0;
  /*background-color: rgba(0,0,0,0.3);*/
}

.item>div {
  float: left;
}

.item div:first-child label:first-child {
  font-size: 14px;
  color: #4168e7;
  line-height: 10px;
  display: block;
}

.item div:first-child label:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}

.hint_pr {
  padding-left: 36px;
  // line-height: 20px;
}

.hint_pr-operation {
  margin-right: 20px;
  float: right !important;
  position: relative;
  z-index: 10;
}

.hint_pr-operation label {
  cursor: pointer;
}

.hint_pr-operation ul {
  display: none;
  position: absolute;
  right: -14px;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1000;
  cursor: pointer;
}

.hint_pr-operation:hover ul {
  display: block;
  border-radius: 3px;
}

.hint_pr-operation ul li {
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.hint_pr-operation ul li:last-child {
  border-bottom: none;
}

.imgSty {
  width: 80px;
  display: block;
}

.mesSty {
  /*display: flex;*/
  /*align-items: center;*/
  margin-bottom: 8px;
}

.mesSty .el-image {
  width: 64px;
  height: 64px;
  float: left;
}

.mesSty .mesFont {
  float: left;
  width: calc(100% - 100px);
  //text-align: center;
}

.mesSty .mesFont p {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-left: 5px;
  color: #333333;
  /*font-size: 12px;*/
  line-height: 27px;
}

.mesSty .mesFont p:nth-child(2) {
  color: #999999;
  font-size: 12px;
}

.mesSty .mesFont p:nth-child(2) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.iconSty {
  float: right;
  cursor: pointer;
}

@media (min-width: 1500px) {}

@media screen and (max-width: 1500px) {
  .item div:first-child label:first-child {
    font-size: 14px;
    color: #4168e7;
    line-height: 20px;
    display: block;
  }

  .item {
    width: 100%;
    height: 40px;
    background-color: #ebeef5;
    padding: 0px 0 7px 50px;
    position: absolute;
    /*top: 0;*/
    left: 0;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }

  .hint_pr {
    padding-left: 8vh;
    line-height: 20px;
  }

  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -32px;*/
  }
}

@media screen and (max-width: 1200px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -25px;*/
  }
}

@media (min-width: 768px) {}

.afterSaleAmount {
  margin-top: 40px;
}

.afterSaleStatus {
  margin-top: 50px;
}
</style>
